export default {
  es: {
    title: "Autoconsumo",
    particulares: {
      title: "Particulares",
      hero: "Saca partido a tu tesoro, tu tejado",
      btnText: "Calcula tu precio",
      banner: {
        image: "/static/img/autoconsumo/premium-residencial.webp",
        title: "Premium",
        subtitle: "Autoconsumo y baterías",
        text: [
          "<strong>Y si quieres lo mejor de lo mejor,</strong> te instalamos las mejores calidades al mejor precio: Paneles marca <strong>SunPower o Hyundai con 25 años de garantía</strong> total, acabados impecables y el máximo rendimiento.",
          "<strong>Y si te interesan baterías,</strong> también te instalamos las más premium  para que pases a ahorrar hasta el 100% de tu factura de la luz y te duren muchísimos años.",
        ],
        link: "/instalaciones-fotovoltaicas-como-funcionan",
      },
      proyectos: {
        title: "Algunos de nuestros proyectos inergizados...",
      },
    },
    agricola: {
      title: "Agricultura",
      hero: "Riega durante el día y cuando quieras",
      btnText: "Pide tu presupuesto",
      banner: {
        image: "/static/img/autoconsumo/bombeo-solar.webp",
        title: "Bombeo",
        subtitle: "Solar",
        text: [
          "<strong>Olvídate de bombear el agua por la noche</strong> o de los altísimos gastos en gasóleo.",
          "<span class='check'><strong>Reducirás los costes de tu regadío casi en el 100%.</strong></span>",
          "<span class='check'><strong>Sin necesidad de cambiar la bomba existente.</strong></span>",
          "<span class='check'>Con un <strong>sistema inteligente y autónomo que podrás controlar desde tu smartphone.</strong></span>",
        ],
        link: "/bombeo-solar-guia-sobre-sus-beneficios-y-uso-en-la-agricultura",
      },
    },
    empresa: {
      title: "Empresas",
      hero: "Es hora de generar tu propia energía",
      btnText: "Calcula tu precio",
      banner: {
        image: "/static/img/autoconsumo/imagen-middle-empresa.webp",
        title: "PPA",
        subtitle: "Inversión CERO",
        text: [
          "Si lo prefieres, pídenos estudio de tu PPA y estabiliza tus costes de energía <strong>sin hacer ninguna inversión.</strong>",
          "<span class='check'><strong>Consumirás tu propia energía</strong> a precios de otra época y sin subidas durante años.</span>",
          "<span class='check'>La planta solar <strong>terminará siendo tuya por 0 €.</strong></span>",
          "<span class='check'><strong>Con opción de compra</strong> por si no quieres esperar a finalizar el contrato…y como cada año te la venderemos más barata, tu rentabilidad será aún mayor.</span>",
          "<strong>¿Quieres saber más?</strong> Accede a nuestro blog",
        ],
        link: "/ppa-o-autoconsumo-con-inversion-cero",
      },
      proyectos: {
        title: "Proyectos que inergizan empresas...",
      },
    },
    btnBanner: "Saber más",
    contratacion: {
      hero: "Contratación",
      heroSubtitle: "Cómo contrato:",
      title: "¡Contratar es muy fácil!",
      subtitle:
        "En menos de 5 minutos puedes disfrutar del autoconsumo de Iner energía.",
      tips: [
        {
          title: "Calcula tu presupuesto",
          image: "/static/img/autoconsumo/contratacion-1.svg",
        },
        {
          title: "Realizamos estudio",
          image: "/static/img/autoconsumo/contratacion-2.svg",
        },
        {
          title: "Visitamos tu tejado",
          image: "/static/img/autoconsumo/contratacion-3.svg",
        },
        {
          title: "Instalamos tus placas",
          image: "/static/img/autoconsumo/contratacion-4.svg",
        },
        {
          title: "¡EMPIEZA A AHORRAR MES A MES!",
          image: "/static/img/autoconsumo/contratacion-5.svg",
        },
      ],
      btn: "Comenzar",
    },
    gestionamos: {
      hero: "Te gestionamos",
      title:
        "Las subvenciones y todas las ventajas fiscales a las que te puedes acoger gracias al autoconsumo",
    },
    proyectos: {
      size: "Tamaño:",
      saving: "Ahorro:",
      production: "Producción:",
      eco: "Medioambiente:",
      btn: "Solicita estudio personalizado",
      loading: "Cargando proyectos...",
    },
  },
  en: {},
};



// WEBPACK FOOTER //
// ./src/translations/autoconsumo.js